import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <p className="text-5xl font-bold text-cygnet-dark">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">Page not found</h1>
      <p className="mt-2 text-gray-600">Sorry, we couldn't find the page you're looking for.</p>
      <div className="mt-8 flex gap-4">
        <Link
          to="/"
          className="rounded-md bg-cygnet-dark px-5 py-2.5 text-sm font-semibold text-white hover:bg-cygnet-DEFAULT transition-colors"
        >
          Go home
        </Link>
        <a
          href="tel:+442085385400"
          className="rounded-md border border-cygnet-dark px-5 py-2.5 text-sm font-semibold text-cygnet-dark hover:bg-gray-50 transition-colors"
        >
          Call us
        </a>
      </div>
    </div>
  );
};

export default NotFound;
